import {
  AddMemberToGroupRequest,
  AddMemberToGroupResponse,
} from "@services/models/Groups/AddMemberToGroup";
import {
  CreateGroupRequest,
  CreateGroupResponse,
} from "@services/models/Groups/CreateGroup";
import {
  GetGroupMembersRequest,
  GetGroupMembersResponse,
} from "@services/models/Groups/GetGroupMembers";
import { GetGroupsResponse } from "@services/models/Groups/GetGroups";
import {
  RemoveGroupRequest,
  RemoveGroupResponse,
} from "@services/models/Groups/RemoveGroup";
import {
  RemoveMemberFromGroupRequest,
  RemoveMemberFromGroupResponse,
} from "@services/models/Groups/RemoveMemberFromGroup";
import { createApiClient } from "../api/createApiClient";
import { AxiosInstance } from "axios";

class GroupManagementApiService {
  private api: AxiosInstance;
  constructor() {
    this.api = createApiClient();
  }

  public async createGroup(
    data: CreateGroupRequest
  ): Promise<CreateGroupResponse> {
    try {
      const response = await this.api.post<CreateGroupResponse>(
        "/adminPanel/groupManagement/createGroup",
        {
          name: data.name,
          description: data.description,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async addMemberToGroup(
    data: AddMemberToGroupRequest
  ): Promise<AddMemberToGroupResponse> {
    try {
      const response = await this.api.post<AddMemberToGroupResponse>(
        "/adminPanel/groupManagement/addMemberToGroup",
        {
          groupId: data.groupId,
          memberId: data.memberId,
          roleType: data.roleType,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async removeMemberFromGroup(
    data: RemoveMemberFromGroupRequest
  ): Promise<RemoveMemberFromGroupResponse> {
    try {
      console.log("API: removeMemberFromGroup called with data:", data);
      const response = await this.api.post<RemoveMemberFromGroupResponse>(
        "/adminPanel/groupManagement/removeMemberFromGroup",
        {
          groupId: data.groupId,
          memberId: data.memberId,
          roleType: data.roleType,
        }
      );
      console.log("API: removeMemberFromGroup response:", response.data);
      return response.data;
    } catch (error) {
      console.error("API: removeMemberFromGroup error:", error);
      throw error;
    }
  }

  public async deleteGroup(
    data: RemoveGroupRequest
  ): Promise<RemoveGroupResponse> {
    try {
      const response = await this.api.post<RemoveGroupResponse>(
        "/adminPanel/groupManagement/deleteGroup",
        {
          groupId: data.groupId,
          softDelete: true,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async getGroups(): Promise<GetGroupsResponse> {
    try {
      const response = await this.api.get<GetGroupsResponse>(
        "/adminPanel/groupManagement/getGroups",
        { params: { isActive: true } }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async getGroupMembers(
    data: GetGroupMembersRequest
  ): Promise<GetGroupMembersResponse> {
    try {
      const response = await this.api.get<GetGroupMembersResponse>(
        "/adminPanel/groupManagement/getGroupMembers",
        { params: { roleType: data.roleType, groupId: data.groupId } }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const groupManagementApi = new GroupManagementApiService();
